/* eslint-disable no-useless-escape */
import Dialog from 'quasar/src/plugins/Dialog.js';;
import ActionOutcomeAlert from "@/components/UI/ActionOutcomeAlert";
import moment from "moment";
moment.locale("en");

export default {
  data() {
    return {};
  },
  methods: {
    backToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    copyToClipboard(string) {
      navigator.clipboard
        .writeText(string)
        .then(() => {
          this.triggerActionOutcomeAlert("copy", true);
        })
        .catch(() => {
          this.triggerActionOutcomeAlert("copy", false);
        });
    },
    convertToObjectById(array, idField = "id") {
      return array.length > 0 && typeof array[0][idField] !== "undefined"
        ? array.reduce((a, b) => ({ ...a, [b[idField]]: b }), {})
        : {};
    },
    convertToObjectOfArraysById(array, idField = "id") {
      if (array.length === 0 || typeof array[0][idField] === "undefined")
        return {};

      let byId = {};
      array.forEach(item => {
        if (typeof byId[item[idField]] === "undefined") {
          byId[item[idField]] = [];
        }
        byId[item[idField]].push(item);
      });
      return byId;
    },
    convertToDateFormatted(date, includeTime = false) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do, YYYY" + (includeTime ? " h:mm A" : ""));
    },
    calculateDaysBetweenNow(date) {
      let momentDate = moment.utc(date).local();
      return moment().diff(momentDate, "days");
    },
    generateSelectOptionsArray(
      array,
      labelField,
      valueField,
      customSort = null
    ) {
      let optionsArray = array.map(item => {
        return { label: item[labelField], value: item[valueField] };
      });

      if (customSort) {
        optionsArray.sort(customSort);
      } else {
        optionsArray.sort((a, b) => {
          return a.label > b.label ? 1 : -1;
        });
      }

      return optionsArray;
    },
    triggerActionOutcomeAlert(type, success, customMessage = "") {
      // TODO: Use Quasar notify plugin instead? (https://quasar.dev/quasar-plugins/notify#introduction)
      Dialog.create({
        component: ActionOutcomeAlert,
        componentProps: {
          type,
          success,
          customMessage
        }
      });
    },
    capitalizeText(text, lowerRemaining = false) {
      return (lowerRemaining
        ? text.toLowerCase()
        : text
      ).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    },
    sortMoney(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return (
        Number(a.replace(/(^\$|,)/g, "")) - Number(b.replace(/(^\$|,)/g, ""))
      );
    },
    sortPercentage(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return (
        Number(a.replace("%", "").replaceAll(",", "")) -
        Number(b.replace("%", "").replaceAll(",", ""))
      );
    },
    sortInteger(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return (
        parseInt(a.toString().replaceAll(",", ""), 10) -
        parseInt(b.toString().replaceAll(",", ""), 10)
      );
    },
    sortDecimal(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return Number(a) - Number(b);
    },
    sortDate(a, b) {
      if (!a) a = "1980-01-01";
      if (!b) b = "1980-01-01";
      return moment(a).unix() - moment(b).unix();
    },
    isFloat(val) {
      return !isNaN(val) && val !== "" && val !== null;
    },
    formatKey(key) {
      return this.capitalizeText(key.replaceAll("_", " "));
    },
    formatDateLocal(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do, YYYY h:mm A");
    },
    getDatePresetRange(datePreset) {
      let presetMap = {
        today: {
          from: moment().format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD")
        },
        yesterday: {
          from: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD"),
          to: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        },
        last_7_days: {
          from: moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD"),
          to: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        },
        last_14_days: {
          from: moment()
            .subtract(14, "days")
            .format("YYYY-MM-DD"),
          to: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        },
        last_30_days: {
          from: moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD"),
          to: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        },
        this_week: {
          from: moment()
            .startOf("week")
            .format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD")
        },
        last_week: {
          from: moment()
            .subtract(7, "days")
            .startOf("week")
            .format("YYYY-MM-DD"),
          to: moment()
            .subtract(7, "days")
            .endOf("week")
            .format("YYYY-MM-DD")
        },
        this_month: {
          from: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD")
        },
        last_month: {
          from: moment()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          to: moment()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD")
        }
      };

      return typeof presetMap[datePreset] !== "undefined"
        ? presetMap[datePreset]
        : presetMap.today;
    },
    isMobileUserAgent() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    formatPhoneNumber(number) {
      let cleaned = ("" + number).replace(/\D/g, "");
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }
      return number;
    },
    getFullStateName(stateAbbreviation) {
      let statesMap = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
      };
      return stateAbbreviation in statesMap ? statesMap[stateAbbreviation] : "Illinois";
    },
    generateStatesSelectOptionsArray() {
      let statesMap = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
      };

      let optionsArray = Object.keys(statesMap).map((abbv) => {
        return { label: statesMap[abbv], value: abbv };
      });

      optionsArray.sort((a, b) => {
        return a.label > b.label ? 1 : -1;
      });

      return optionsArray;
    },
  }
};
